import { ClientPageTab, PeopleSegment } from '@/components/Clients/clientPageTabs'
import { laravelNamedRoute } from '@/utils/laravelNamedRoutes'
import namedRoutes from '@/utils/laravelNamedRoutes.json'

// Mirrors the client page, which never writes the default segment.
export const peopleQuery = (segment: PeopleSegment): Record<string, string> =>
  segment === PeopleSegment.Team
    ? { tab: ClientPageTab.People }
    : { tab: ClientPageTab.People, people: segment }

export const clientPeopleUrl = (companySupplierId: string, segment: PeopleSegment): string =>
  laravelNamedRoute(namedRoutes.frontend.clients.view, {
    companySupplier: companySupplierId,
    ...peopleQuery(segment),
  })
